import {Injectable} from '@angular/core';
import {ExamFormModel} from '../model/exam-form.model';
import {FormConverter} from '../../../form/form/api/entity/converter/form.converter';
import {HttpModelConverter} from '../../../core/converter/httpModel.converter';
import {
    ConsultationSummaryConverter
} from "../../../medical/consultation/consultation/api/model/converter/consultationSummary.converter";

@Injectable()
export class ExamFormConverter extends HttpModelConverter<ExamFormModel> {

    constructor(private formConverter: FormConverter,
                private consultationSummaryConverter: ConsultationSummaryConverter) {
        super();
    }

    protected createInstance(): ExamFormModel {
        return new ExamFormModel();
    }

    protected enrichObject(result: ExamFormModel, src: ExamFormModel) {
        result.form = this.formConverter.convert(src.form);
        result.consultation = this.consultationSummaryConverter.convert(src.consultation);
    }
}
